export function withIds(labels: string[]) {
  return labels.map((label, index) => ({
    id: index.toString(),
    label
  }));
}
